import http from "./http";

/* ===============================
   GET ALL ROLES
================================ */
export const getRoles = async () => {
  const res = await http.get("/roles");
  return res.data;
};

/* ===============================
   GET ROLE BY ID
================================ */
export const getRoleById = async (id) => {
  const res = await http.get(`/roles/${id}`);
  return res.data;
};

/* ===============================
   ADD ROLE
================================ */
export const addRole = async (payload) => {
  const res = await http.post("/roles", payload);
  return res.data;
};

/* ===============================
   UPDATE ROLE
================================ */
export const updateRole = async (id, payload) => {
  const res = await http.put(`/roles/${id}`, payload);
  return res.data;
};

/* ===============================
   DELETE ROLE
================================ */
export const deleteRole = async (id) => {
  const res = await http.delete(`/roles/${id}`);
  return res.data;
};
